import { h, render } from 'preact';
import SupergoopModal from "./supergoop-modal";

export default (element, data) => {

  const init = () => {

    render(
      <SupergoopModal {...data}/>,
      element,
    );
  };

  init();
};
